import ApiService from './_api.service'
import { Product as Model } from '@/models/product.model'

const PRODUCTS_URL = '/v1/products/'

import { NewBranchParameter } from '@/models/branchparameter.model'
import { NewDCParameter } from '@/models/dcparameter.model'

const ProductService = {
    create: function(entity) {
        let data = new FormData()
        Object.keys(Model.editableFields).forEach(field => {
            if (entity[field] != null) data.set(field, entity[field])
        })
        return ApiService.post(PRODUCTS_URL, data)
    },
    read: function(args) {
        let queryParams = '?'
        if (args) {
            if (typeof args == 'number') {
                queryParams = args + '/'
            } else
                Object.keys(args).forEach(key => {
                    if (args[key] != null && args[key] != '')
                        queryParams += key + '=' + args[key] + '&'
                })
        }
        return ApiService.get(PRODUCTS_URL + queryParams)
    },

    readSolicitationProd: function(args) {
        let queryParams = '?'
        if (args) {
            if (typeof args.q == 'number') {
                queryParams += 'id=' + args.q
            }
        }
        return ApiService.get(PRODUCTS_URL + queryParams)
    },

    readSolicitationProdCommonId: function(args) {
        let queryParams = '?'
        if (args) {
            queryParams += 'external_common_id=' + args.q
        }
        return ApiService.get(PRODUCTS_URL + queryParams)
    },

    readSolicitationProdVoltage: function(args) {
        let queryParams = '?voltage='
        if (args) {
            args.q.forEach(value => {
                queryParams += value + '_'
            })
        }
        return ApiService.get(PRODUCTS_URL + queryParams)
    },

    readSolicitationProdColors: function(args) {
        let queryParams = '?'
        if (args) {
            queryParams += 'color_id=' + args.q
        }
        return ApiService.get(PRODUCTS_URL + queryParams)
    },

    readColors: function(args) {
        let queryParams = '?'
        if (args) {
            if (typeof args == 'number') queryParams = args + '/'
            else
                Object.keys(args).forEach(key => {
                    if (args[key] != null && args[key] != '')
                        queryParams += key + '=' + args[key] + '&'
                })
        }
        return ApiService.get('/v1/products/colors/' + queryParams)
    },

    readSolicitationNewProd: function(args) {
        let queryParams = '?new_product='
        if (args) {
            args.q.forEach(value => {
                queryParams += value + '_'
            })
        }
        return ApiService.get(PRODUCTS_URL + queryParams)
    },

    readById: function(id) {
        if (!id) return

        return ApiService.get(PRODUCTS_URL + id)
    },

    update: async function(id, entity) {
        let data = new FormData()
        Object.keys(Model.editableFields).forEach(field => {
            if (entity[field] != null) data.set(field, entity[field])
        })
        return ApiService.patch(PRODUCTS_URL + id + '/', data)
    },

    delete: async function(id) {
        return ApiService.delete(PRODUCTS_URL + id + '/')
    },

    createParameter: function(entity) {
        let data = new FormData()

        Object.keys(NewBranchParameter.createFields).forEach(field => {
            // if (entity[field] != null) data.set(field, entity[field])
            data.set(field, entity[field])
        })

        Object.keys(NewDCParameter.createFields).forEach(field => {
            // if (entity[field] != null)
            data.set(field, entity[field])
        })

        data.set('product_id', entity['product_id'])

        return ApiService.post(PRODUCTS_URL + 'parameter/', data)
    }
}

export default ProductService
export { ProductService }
